import { render, staticRenderFns } from "./CollectionTabLinks.vue?vue&type=template&id=5d4fa324&"
import script from "./CollectionTabLinks.vue?vue&type=script&lang=js&"
export * from "./CollectionTabLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports